import { Card, Column, Text } from '~/commonComponents';

export const HelpSection = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <Card>
    <Column paddingVertical={40} paddingLeft={48}>
      <Text bold fontSize={20} color="primary_500">
        {title}
      </Text>
      <Column gap={20} marginTop={20} marginLeft={20}>
        {children}
      </Column>
    </Column>
  </Card>
);
